import React, {Component} from "react";

export class LearnSection extends Component {
    render() {
        let {children, title} = this.props;
        return <div className="row">
            {title ? <div className="col-12"><h2>{title}</h2></div> : null}
            {children}
        </div>;
    }
}